import { Image, View, StyleSheet } from '@react-pdf/renderer';

import { PDF_COLORS } from '@/client/features/issue/pdf/styles';

const styles = StyleSheet.create({
  // Inline image frame: max 50% of body width, left-aligned, gray surround.
  frame: {
    width: '50%',
    backgroundColor: PDF_COLORS.imageFrameBg,
    padding: 8,
    alignSelf: 'flex-start',
    marginVertical: 10,
  },
  image: {
    maxWidth: '100%',
    maxHeight: 360,
    objectFit: 'contain',
  },
});

export const RemoteImage = ({ src }: { src: string | undefined }) => {
  if (!src) return null;

  return (
    <View style={styles.frame}>
      <Image src={src} style={styles.image} />
    </View>
  );
};
